import { Row, Col, Divider, Form } from "antd";
import { RightOutlined } from "@ant-design/icons";
import Image from "next/image";
import { Input, Button, MaskedInput } from "@dreambigger/design-system/src/components";
import { optimizeCloudinaryImg } from "@dreambigger/shared/src/utils";
import { Header, CodeVerification } from "../../components";
import styles from "../start.module.scss";
import { StartTemplateProps } from "./types";

export default function DefaultTemplate({
  assets,
  brand,
  flow,
  hideHeader,
  loginForm,
  keyByLoginMode,
  formattedCred,
  emailInputRef,
  phoneInputRef,
  handleNext,
  isAdminMode,
  codeVerificationProps,
}: StartTemplateProps) {
  return (
    <div className={`${styles.homePage} w-100 h-100 min-h-100vh`}>
      {!hideHeader && <Header brand={brand} />}

      <Row
        className={`${styles.mainContainer} pv-6 sm_pv-10 br-2`}
        style={{
          background:
            assets.heroBackground === "secondaryColor"
              ? brand.secondaryColor
              : assets.heroBackground
              ? `url(${assets.heroBackground})`
              : `linear-gradient(180deg, rgba(${
                  assets.heroBackgroundColor1 || "249,249,249"
                }) 0%, rgba(${
                  assets.heroBackgroundColor2 || "249,249,249"
                }) 100%)`,
        }}
      >
        <Col xs={24} lg={12}>
          <h1
            className={`lh-1 textSecondary f-8 sm_f-9 fwb mb-2 mt-0`}
            dangerouslySetInnerHTML={{
              __html: assets.title ?? "",
            }}
          />

          <h2
            className={`${styles.subTitle} textSecondary f-6 sm_f-7 fwn lh-1 mb-6`}
            dangerouslySetInnerHTML={{
              __html: assets.subTitle ?? "",
            }}
          />
          <h3
            className={`${styles.description} textSecondary fwn f-4 sm_f-5 lh-2 pb-4`}
            dangerouslySetInnerHTML={{
              __html: assets.description ?? "",
            }}
          />
          <Divider className={styles.divider} />
          <Form
            form={loginForm}
            initialValues={{ [keyByLoginMode]: formattedCred }}
            onFinish={handleNext}
          >
            <label
              className="textSecondary f-5 fwb"
              dangerouslySetInnerHTML={{
                __html:
                  assets.loginTitle || "Sign up in less than 5 minutes!",
              }}
            />
            <Row gutter={8} className="mt-2 sm_mt-1" align="top">
              <Col xs={24} lg={14} style={{ alignItems: "start" }}>
                <Form.Item name={keyByLoginMode} style={{ marginBottom: 16 }}>
                  {flow.financialInstitution.loginMode === "email" ? (
                    <Input
                      placeholder={assets.loginPlaceholder}
                      type="email"
                      ref={emailInputRef}
                      className={`br-5 pa-3 mt-0 md_mt-0 ${
                        isAdminMode && "disabled notAllowed"
                      }`}
                      style={{ height: 54 }}
                      readOnly={isAdminMode}
                      required
                    />
                  ) : (
                    <MaskedInput
                      placeholder={assets.loginPlaceholder}
                      mask="(000) 000-0000"
                      name="phone"
                      className={`br-5 pa-3 mt-0 md_mt-0 ${
                        isAdminMode && "disabled notAllowed"
                      }`}
                      ref={phoneInputRef}
                      readOnly={isAdminMode}
                    />
                  )}
                </Form.Item>
              </Col>

              <Col
                xs={24}
                lg={{
                  flex: "100px",
                }}
              >
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="lift h-8 ph-6 mt-2 md-auto"
                  >
                    {assets.submitButtonText} <RightOutlined />
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
        {assets.heroImage && (
          <Col xs={24} lg={12} className="lg_pl-8">
            <div
              className={`${styles.heroImage} ${
                !assets.hideStartImageShadow && "sr-4 sm_sr-7"
              }`}
            >
              <Image
                src={optimizeCloudinaryImg(assets.heroImage)}
                layout="fill"
                objectFit="cover"
                objectPosition="top"
                priority={true}
                alt={"hero image"}
              />
            </div>
          </Col>
        )}
      </Row>
      <Row className={`${styles.termsContainer}`}>
        <Col xs={20} lg={10}>
          <div className="fwb f-4">{assets.landingTermsTitle} </div>
          <div
            className={`${styles.terms} fwn f-4 lh-4`}
            dangerouslySetInnerHTML={{
              __html: assets.landingTermsText ?? "",
            }}
          />
        </Col>
      </Row>
      <CodeVerification {...codeVerificationProps} />
    </div>
  );
}
